<template>
    <div class="app">
        <div class="hero-container">
            <div
                class="hero-container__title"
                :style="{ top: titlePosition + 'vh' }"
            >
                Hanami
            </div>
            <transition mode="out-in" name="enter-card">
                <div class="hero-container__card" v-if="inGame">
                    <transition mode="out-in" name="slide-fade">
                        <Card
                            :key="(state.card && state.card.id) || -1"
                            v-bind:backText="
                                (state.card && state.card.verso) || ''
                            "
                            v-bind:front-text="
                                (state.card && state.card.recto) || ''
                            "
                        />
                    </transition>
                </div> </transition
            >>
            <div class="hero-container__reactions">
                <Reactions :inGame="inGame" :currentCard="state.card" :previous="previous"/>
            </div>
        </div>
        <div
            class="slider"
            v-bind:style="{ transform: `translateY(-${menuHeight}vh)` }"
        >
            <Menu
                v-if="!inGame"
                v-bind:current="state.current"
                v-bind:switchState="switchState"
                v-bind:list="state.list || []"
                v-bind:name="state.name || ''"
                v-bind:previous="previous"
            />
        </div>
    </div>
</template>

<script>
import Menu from "./components/Menu";
import Reactions from "./components/Reactions";
import Card from "./components/Card";

export default {
    name: "app",
    props: ["state", "switchState", "previous"],
    components: {
        Menu,
        Reactions,
        Card,
    },
    computed: {
        menuHeight: function() {
            if (this.state.current !== "home") {
                if (this.state.current === "card") {
                    return "0";
                } else {
                    return "66";
                }
            } else {
                return "66";
            }
        },
        titlePosition: function() {
            return this.inGame ? 6 : 12;
        },
        inGame: function() {
            return this.state.current === "card";
        },
    },
};
</script>

<style>
body {
    margin: 0;
    padding: 0;
}

.app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    background: #f4f9fa;
    background: linear-gradient(
        160deg,
        #f4f9fa 0%,
        rgba(255, 255, 255, 1) 100%
    );
    width: 100vw;
    height: 100vh;
    padding: 0;
    margin: 0;
    overflow: hidden;
}

.hero-container {
    background: rgb(255, 183, 197);
    background: linear-gradient(
        160deg,
        rgba(255, 183, 197, 1) 0%,
        rgba(255, 255, 255, 1) 100%
    );
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
}

.hero-container__title {
    position: absolute;
    font-size: 5em;
    color: white;
    text-shadow: 0 0 5px black;
    transition: top 1s;
}

.hero-container__card {
    position: absolute;
    top: 22vh;
}

.hero-container__reactions {
    position: absolute;
    top: 85vh;
}

.slider {
    width: 100vw;
    height: 66vh;
    background-color: white;
    border-top: solid 3px black;
    transition: transform 0.6s ease-out;
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s ease;
}
.slide-fade-enter {
    transform: translateX(-50px);
}
.slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(50px);
    opacity: 0;
}

.enter-card-enter{
    transform: translateX(50px);
    opacity: 0;
}
.enter-card-leave-to {
    transform: translateX(50px);
    opacity: 0;
}
.enter-card-enter-active {
    transition: all 0.5s ease;
    transition-delay: 0.2s;
}
.enter-card-leave-active {
    transition: all 0.3s ease;
}
</style>
